import { createFileRoute } from '@tanstack/react-router'

// /jobs/$jobId — job selected, no report open: the URL of the NAV STACK's middle level, the job's integrants
// list, with the report one push further in. A real route rather than a search-param flag is what lets browser
// Back pop the stack, keeps the level deep-linkable, and separates "opened the job" from "asked for its report".
//
// It renders nothing into the report Outlet: on mobile that pane is off-stage, on desktop it is the empty detail
// pane. The `jobs.$jobId` layout above owns the chrome + report prefetches, so this leaf needs no loader.
export const Route = createFileRoute('/_app/jobs/_list/$jobId/')({})
